const extractChartColors = (ref: any, type: string) => {
  if (!ref?.current?.props) return {};

  const {options, series} = ref.current.props;

  switch (type) {
    case 'bar':
    case 'line': {
      const barChartColors = options?.colors || [];
      return series?.reduce(
        (acc: Record<string, string>, item: any, index: number) => {
          acc[item.name] = barChartColors[index] || null;
          return acc;
        },
        {}
      );
    }
    case 'pie': {
      const pieChartColors = options?.colors || [];
      return options?.labels?.reduce(
        (acc: Record<string, string>, item: any, index: number) => {
          acc[item] = pieChartColors[index] || null;
          return acc;
        },
        {}
      );
    }
    default:
      return {};
  }
};

export const fetchChartColors = (setState: any, refObj: any) => {
  //   const refObj = [{ref: chartRef, type: 'bar', name: 'bar_chart_01'}];

  const output_chart_colors: any = {};

  refObj.map((item: any) => {
    output_chart_colors[item.name] = extractChartColors(item.ref, item.type);
  });
  setState(output_chart_colors);
};
